export const GeneralLedgerCategories = {
    1: 'Sales',
    2: 'Purchase'
}
export const VatCategories = {
    1: 'Zero',
    2: 'Low',
    3: 'High'
}

// Entity ids by country.
export const Entity = { NL: 1, DE: 2, BE: 3, UK: 4 }

// UK only has two VAT-service accounts of its own, so it also draws on NL's
// purchase ledgers. Mirrors PURCHASE_LEDGER_SHARED_FROM on the server.
export const PurchaseLedgerSharedFrom = { [Entity.UK]: Entity.NL }

// Every entity whose purchase ledgers are available to `entityId`.
export const purchaseLedgerEntityIds = (entityId) => {
    const shared = PurchaseLedgerSharedFrom[Number(entityId)]
    return shared ? [Number(entityId), shared] : [Number(entityId)]
}

const SALES_CATEGORY = 1

// Sales ledgers an invoice line with this VAT type may be booked on — the entity's sales
// ledgers in the VAT's bucket (vat_category), or all of its sales ledgers when the bucket
// has none. Mirrors general_ledger.getSalesCandidates on the server.
export const salesLedgersForVat = (generalLedgers, vatType) => {
    if (!vatType) return []
    const sales = generalLedgers
        .filter(({ entity_id, category }) => entity_id === vatType.entity_id && category === SALES_CATEGORY)
        .sort((a, b) => (b.priority - a.priority) || String(a.code).localeCompare(String(b.code)))
    const inBucket = vatType.vat_category ? sales.filter(({ vat_category }) => vat_category === vatType.vat_category) : []
    return inBucket.length ? inBucket : sales
}

// Default pick: a priority ledger, else the generic "Overige producten", else the first.
// Mirrors general_ledger.defaultSalesLedger on the server.
export const defaultSalesLedger = (candidates) => (
    candidates.find(({ priority }) => priority)
    ?? candidates.find(({ name }) => /overige producten/i.test(name ?? ''))
    ?? candidates[0]
    ?? null
)
